import BaseStimulusModelController from "../../Features/BaseStimulusModelController";
import { getScoreFunctionPreservingOrderInSearch, selectize } from "../selectizeHelper";
import { DestinationsIndexStimulusModel } from "../_generated/DestinationsIndexStimulusModel";

export default class IndexController extends BaseStimulusModelController<DestinationsIndexStimulusModel> {
    static targets = [
        "language",
        "country"
    ];

    readonly hasLanguageTarget!: boolean;
    readonly languageTarget!: HTMLElement;

    readonly hasCountryTarget!: boolean;
    readonly countryTarget!: HTMLElement;

    connect() {   
        if (this.hasLanguageTarget) {
            selectize($(this.languageTarget), {
                score: getScoreFunctionPreservingOrderInSearch
            });
        }
        if (this.hasCountryTarget) {
            selectize($(this.countryTarget), {
                score: getScoreFunctionPreservingOrderInSearch
            });
        }
    }
}
